import { teamHasDialler, users } from "./usersAndGroups.js";

export const statCardGroupUserFilterOptions = [
  { value: "groups", label: "Group", default: true },
  { value: "users", label: "User" },
];

export const statCardTooltipMessages = {
  messaged: "contacts moved from the Sourced to Messaged stages.",
  calls: "calls were completed as part of your campaign To-Dos.",
  opens:
    "of your contacts have opened your outreach. This reflects open rates for emails that have tracking enabled.",
  replies: "of your outreach received replies from contacts.",
  interested:
    "of contacts expressed interest, showing engagement generated from your outreach.",
  meetings:
    "meetings were booked with contacts, representing successful engagement with your contacts.",
};

export const statCardUsersFilteredByGroups = (selectedGroups) => {
  const groupIds = selectedGroups.map((group) => group.value);
  return users.filter(
    (user) =>
      user.groupIds.some((id) => groupIds.includes(id)) ||
      (user.groupIds.length === 0 && groupIds.includes("unassignedUsers")),
  );
};

const nullStats = {
  messaged: {
    value: 0,
    title: "Messaged",
    type: "num",
    stage: "sent",
  },
  opens: {
    value: null,
    title: "Opens",
    type: "%",
    stage: "opened",
  },
  calls: {
    value: 0,
    title: "Calls",
    type: "num",
    stage: "calls",
  },
  replies: {
    value: null,
    title: "Replies",
    type: "%",
    stage: "replied",
  },
  interested: {
    value: null,
    title: "Interested",
    type: "%",
    stage: "interested",
  },
  meetings: {
    value: 0,
    title: "Meetings",
    type: "num",
    stage: "booked",
  },
};

export const nullStatCardStats = Object.fromEntries(
  Object.entries(nullStats).filter(
    ([key]) => key !== (teamHasDialler ? "opens" : "calls"),
  ),
);
